const styles = (theme) => ({
  content: {
    width: '100%',
    padding: '24px 24px 0px 24px',
  },
  title: {
    ...theme.typography.t20,
    textTransform: 'uppercase',
    fontWeight: 700,
    color: theme.palette.primary.teal.main,
  },
  gutterTop: {
    marginTop: 12,
    marginRight: 10,
  },
  helperText: {
    fontSize: '1rem',
    marginLeft: 0,
  },
  infoIcon: {
    color: theme.palette.primary.active,
  }, 
  popoverPaper: {
    width: 275,
    padding: 10,
    backgroundColor: theme.palette.colors.inputBackground,
    color: theme.palette.text.sub,
  },
  disabled: {
    color: theme.palette.primary.black,
    opacity: 0.38
  },
});

export default styles;
